import React from 'react';
import PropTypes from 'prop-types';
import { DATE_FORMAT } from '../../constants/constants';
import Moment from 'moment';

const PushdownPreviewResults = ({ results, isProjectWidgetActive }) => {

    const dateTypeString = (isProjectWidgetActive) ? "Zero Date" : "Opening Date";

    return (
        <div>
            {results === null ?
                ""
                :
                <div>
                    <div className="alert alert-secondary">Results for {dateTypeString} of <strong>{Moment.utc(results.openingDate).format(DATE_FORMAT)}</strong></div>
                    <table className="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Task Name</th>
                                <th scope="col">Target Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.tasks.map(task =>
                                <tr key={task.id}>
                                    <td>
                                        <label>{task.name}</label>
                                    </td>
                                    <td>
                                        <label>{Moment.utc(task.targetDate).format(DATE_FORMAT)}</label>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            }

        </div>

    )
}

PushdownPreviewResults.propTypes = {
    results: PropTypes.object,
    isProjectWidgetActive: PropTypes.bool.isRequired
}

export default PushdownPreviewResults;
